import { render } from "./Mentor.vue?vue&type=template&id=05d4448c"
import script from "./Mentor.vue?vue&type=script&lang=js"
export * from "./Mentor.vue?vue&type=script&lang=js"

import exportComponent from "/home/parallels/Web/Repos/mentee-mentor/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__